import ResizeObserver from "resize-observer-polyfill"
import { useRef, useLayoutEffect } from "react"

const useResizeObserver = (target: any, onResize: any) => {
  const resizeObserver = useRef(null)
  useLayoutEffect(() => {
    // @ts-expect-error TS(2322): Type 'ResizeObserver' is not assignable to type 'n... Remove this comment to see the full error message
    resizeObserver.current = new ResizeObserver(() => {
      onResize && onResize()
    })
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    resizeObserver.current.observe(target)
    return () => {
      if (resizeObserver.current) {
        // @ts-expect-error TS(2339): Property 'disconnect' does not exist on type 'neve... Remove this comment to see the full error message
        resizeObserver.current.disconnect()
      }
    }
  }, [onResize, target])
}
export default useResizeObserver
